import { useAccountStore } from '../../common'
import { useAccountUiStore } from './useUiStore'

export const useGetMergeableAccounts = () => {
  const { accounts } = useAccountStore()
  const { selectedAccount, selectedMember } = useAccountUiStore()
  return accounts.filter(
    (account) =>
      account.member_guid === selectedMember.guid &&
      selectedMember.successfully_aggregated_at &&
      account.guid !== selectedAccount.guid,
  )
}
